// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import getCanOrderSample from "@store/Framework/Common/Utilities/samples/getCanOrderSample";
import { HasSampleModelParameter } from "@store/Framework/Common/Utilities/samples/getHasSample";
import { getIsB2BCustomer } from "@store/Framework/Store/Data/BillTos/BillTosSelectors";

function getCanOnlyOrderSample(state: ApplicationState, model: HasSampleModelParameter): boolean;
function getCanOnlyOrderSample(isB2BCustomer: boolean, model: HasSampleModelParameter): boolean;
function getCanOnlyOrderSample(param: ApplicationState | boolean, model: HasSampleModelParameter): boolean {
    const isB2BCustomer = typeof param === "boolean" ? param : getIsB2BCustomer(param);

    return getCanOrderSample(isB2BCustomer, model) && !isB2BCustomer;
}

export default getCanOnlyOrderSample;
